/**
 * 모달·메뉴가 열려 있는 동안 뒤 페이지 스크롤을 막는다.
 *
 * 몇 개가 열려 있는지 세서, 마지막 하나가 닫힐 때만 스크롤을 다시 푼다.
 * 각자 막고 푸는 방식이면 모달 두 개를 겹쳐 열었다 닫을 때 스크롤이 잠긴 채로 남는다.
 *
 * 스크롤을 막아야 하는 곳은 모두 이 함수를 써야 한다.
 * 따로 `body.style.overflow` 를 바꾸면 개수가 안 맞아 같은 문제가 다시 생긴다.
 */
let depth = 0;
let previousOverflow = '';

export function lockBodyScroll(): () => void {
  if (depth === 0) {
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }
  depth += 1;

  let released = false;
  return () => {
    // 같은 잠금을 두 번 풀어도 한 번만 센다.
    if (released) return;
    released = true;
    depth -= 1;
    if (depth === 0) document.body.style.overflow = previousOverflow;
  };
}
